import { shape, string } from "prop-types"
import { Icon } from "source/shared/icons"
import { Date } from "source/shared/DatetimeFmt"
import { useContext } from "react"
import { WebBootContext } from "source/publishing/WebBoot"

AddressField.propTypes = {
  field: shape({
    attributes: shape({
      street: string,
      city: string,
      state: string,
      zip: string,
    }),
  }).isRequired,
}

export function AddressField({ field }) {
  const { features } = useContext(WebBootContext)

  return (
    <span className="d-f mt-1" title="Address">
      <Icon
        className="fs-4 c-tint3 mr-1 mt-3p"
        symbol="general#location-pin"
        aria-hidden
      />
      <div className="d-f fd-c fw-400 c-tint2">
        <div className="lh-1.25 mb-4p">{field.attributes.street}</div>
        <div className="lh-1.25">
          {field.attributes.city}, {field.attributes.state}{" "}
          {field.attributes.zip}
        </div>
        {features.ROLLOUT_address_country_code &&
          !!field.attributes.country_name && (
            <div className="mt-4p">{field.attributes.country_name}</div>
          )}
      </div>
    </span>
  )
}

EmailField.propTypes = {
  field: shape({ attributes: shape({ address: string }) }).isRequired,
}

export function EmailField({ field }) {
  return (
    <span className="d-f ai-c mt-1" title="Email address">
      <Icon
        className="fs-4 c-tint3 mr-1 mt-2p"
        symbol="general#envelope"
        aria-hidden
      />
      <a
        className="emailField f-1 fw-400 c-tint2 lh-1.25"
        href={`mailto:${field.attributes.address}`}
      >
        {field.attributes.address}
      </a>
    </span>
  )
}

PhoneNumberField.propTypes = {
  field: shape({ attributes: shape({ number: string }) }).isRequired,
}

export function PhoneNumberField({ field }) {
  return (
    <span className="d-f ai-c mt-1" title="Phone number">
      <Icon
        className="fs-4 c-tint3 mr-1"
        symbol="general#mobile-phone"
        aria-hidden
      />
      <a
        className="fw-400 c-tint2 lh-1"
        href={`tel:${field.attributes.number}`}
      >
        {field.attributes.number}
      </a>
    </span>
  )
}

BirthdayField.propTypes = {
  birthday: string,
}

export function BirthdayField({ birthday }) {
  if (birthday && birthday.length) {
    return (
      <span className="d-f ai-b mt-1" title="Birthday">
        <Icon
          className="fs-4 c-tint3 mr-1"
          symbol="check-ins#birthday"
          aria-hidden
        />
        <div className="d-f fd-c ta-c">
          <div className="fw-400 c-tint2 lh-1">
            <Date start={birthday} style="standard" />
          </div>
        </div>
      </span>
    )
  } else {
    return null
  }
}

AnniversaryField.propTypes = {
  anniversary: string,
}

export function AnniversaryField({ anniversary }) {
  if (anniversary && anniversary.length) {
    return (
      <span className="d-f ai-c mt-1" title="Anniversary">
        <Icon
          className="fs-4 c-tint3 mr-1"
          symbol="general#heart"
          aria-hidden
        />
        <div className="d-f fd-c ta-c">
          <div className="fw-400 c-tint2 lh-1">
            <Date start={anniversary} style="standard" />
          </div>
        </div>
      </span>
    )
  } else {
    return null
  }
}
